import React from "react";
import { Icon } from "@showitinc/showit-wc";
import cx from "classnames";

import styles from "./UpgradedIcon.module.css";

/**
 * Badge shown for designs locked into the v2 publish engine. Size is driven
 * by the `--size` CSS custom property.
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @returns {React.ReactElement}
 */
const UpgradedIcon = ({ className }) => (
  <div className={cx(className, styles.upgradedIcon)}>
    <Icon className={styles.checkIcon} type="check" />
    <Icon className={styles.backgroundIcon} type="Upgraded" />
  </div>
);

export default UpgradedIcon;
